import { render, staticRenderFns } from "./WDatepicker.vue?vue&type=template&id=4b7c4188&scoped=true"
import script from "./WDatepicker.vue?vue&type=script&lang=js"
export * from "./WDatepicker.vue?vue&type=script&lang=js"
import style0 from "./WDatepicker.vue?vue&type=style&index=0&id=4b7c4188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c4188",
  null
  
)

export default component.exports